import React from 'react';
import CountUp from 'react-countup';
import DeltaBadge from '../../Shared/DeltaBadge';
import { formatMoney, formatNumber } from '../../Shared/Formatters';

function fmt(value, format) {
    if (value == null || isNaN(value)) return '—';
    if (format === 'currency') return formatMoney(value);
    if (format === 'integer') return formatNumber(value, 0);
    return String(value);
}

/**
 * KPI grid — responsive cells with animated CountUp number + delta chip.
 * Used in briefing blocks. Each item: {label, value, prior, delta_pct, format}.
 */
export default function KpiGrid({ title, items }) {
    if (!items?.length) return null;
    return (
        <div className="chat-block">
            {title && <div className="chat-block-title">{title}</div>}
            <div className="kpi-grid">
                {items.map((it, i) => {
                    const isMoney = it.format === 'currency';
                    return (
                        <div key={i} className="kpi-cell">
                            <div className="kpi-cell-label">{it.label}</div>
                            <div className="kpi-cell-value" title={fmt(it.value, it.format)}>
                                {it.value == null || isNaN(it.value) ? '—' : (
                                    <CountUp
                                        end={Number(it.value)}
                                        duration={0.8}
                                        separator=","
                                        decimals={0}
                                        formattingFn={isMoney ? formatMoney : undefined}
                                    />
                                )}
                            </div>
                            {it.delta_pct != null && (
                                <div className="kpi-cell-delta">
                                    <DeltaBadge value={it.delta_pct} suffix="%" />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
